/**
 * @file Deck/component.js
 * @copyright 2015 CBC/Radio-Canada. All rights reserved.
 */

type DeckProps = {
    text?: string;
    lang?: string;
};
/**
 * Deck component for detail page.
 *
 * @param {Object} props The supplied component props
 * @returns {React.Component} The Deck component
 */
export function Deck({ text, lang }: DeckProps) {
    if (!text) {
        return null;
    }
    return (
        <h2 className="deck" lang={lang} data-testid="deck">
            {text}
        </h2>
    );
}

export default Deck;
